module.exports = __webpack_public_path__ + "static/media/section-3-1@2x.c2d83ba2.png";